"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultReverifyEmailResultState = exports.defaultReverifyEmailResultTranslate = void 0;
exports.defaultReverifyEmailResultTranslate = {
    nameReverifyEmailTitle: 'Resend verification email',
    nameReverifyEmailCaption: 'Send verification email again',
    needSupportTitle: 'Need Support?',
    needSupportEmail: 'support@okay.com',
    needSupportPhone: '+852 2102 0888',
    submitSuccess: 'Password Recovery Request Submitted',
    submitSuccessCaption: '',
    instructionSentTo: 'An instruction has been sent to',
    clickToContinue: 'Please follow the instructions in the email to change your password',
    goto: 'Go to',
    mailBox: 'Mailbox',
};
exports.defaultReverifyEmailResultState = {
    t: exports.defaultReverifyEmailResultTranslate,
    email: 'dsad@dasd.com',
    mailBoxUrl: 'https://mail.okay.com',
    mailBoxName: 'Okay.com',
};
